<template>
  <div class="absolute bottom-0 left-0 translate-x-6 md:left-1/2 md:-translate-x-1/2 z-[100] pointer-events-none">
    <UIcon name="lucide:chevrons-down" class="size-12 text-white/50 animate-bounce" />
  </div>
</template>
